import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    message: PropTypes.string,
};

const defaultProps = {
    message: '',
};

function LogoPanelHeader(props) {
    return (
        <div className="header">
            <div className="logo-img">
                <img
                    src={`${GlobalConfig.StaticUrl}/img/logo-vert.svg`}
                    alt="Muzzy Lane Author"
                />
            </div>
            <br/>
            <div className="logo-message">
                {props.message}
            </div>
        </div>
    );
}

LogoPanelHeader.propTypes = propTypes;
LogoPanelHeader.defaultProps = defaultProps;

export default LogoPanelHeader;
